import { Outlet, Link } from 'react-router-dom'
import Button from '../ui/Button'

export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-graysoft">
      <header className="h-16 bg-white border-b border-gray-100 flex items-center justify-between px-8">
        <Link to="/" className="flex items-center gap-2">
          <div className="w-8 h-8 bg-navy rounded-lg flex items-center justify-center">
            <span className="text-teal font-bold text-lg">T</span>
          </div>
          <span className="font-bold text-navy text-lg">tapio</span>
        </Link>
        <div className="flex items-center gap-3">
          <Link to="/login">
            <Button variant="ghost" size="sm">Connexion</Button>
          </Link>
          <Link to="/register">
            <Button variant="primary" size="sm">Créer un compte</Button>
          </Link>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
    </div>
  )
}